
export const Query = {
  // Special query value that force the query param to be removed.
  // used to force remove the query parameters to keep on all pages.
  // see actions.js#generatePathWithParams
  REMOVE_ME: 'QUERY::REMOVE_ME',
}
